import { getCountryList } from './countries'
import { getInfo } from './info'

export default {
  getInfo,
  getCountryList,
}
